// @ts-nocheck
import React, { createRef } from "react";
import BaseComponent from "../../../../../base/common/BaseComponent";
import ProcedureBlock from "../../../../../base/basicComponents/procedureBlock";
import PageHeader from "../../../../commonComponents/pageHeaders/PageHeader";
import TaskInformation from "../../../../sections/taskInfoSections";
import ProcedureInformation from "../../../../sections/procedureInfoSections/readOnlyProcedureInfoSection";
import ActiveShareTaskReadOnly from "../../../../sections/sharedTaskSections/activeShareTaskReadOnly";
import styles from "../../style/index.module.scss";
import ReadOnlySupportingFileSection from "../../../../sections/supportingFileSections/readOnlySupportingFileSection";
import StepService from "../../../../../service/stepBase/StepService";
import CompleteStepBusinessType from "../../../../../service/stepBase/completeStepBusinessType";
import renderHighlight from "utils/highlight";

const supportingFileRef = createRef();
const supportingFileTableRef = createRef();
export default class BaseProcedureComplete extends BaseComponent {
  componentDidMount() {
    renderHighlight();
  }
  /**
   * function about return procedure file section
   */
  handleReturnProcedureFileSection = () => {
    // this is an empty function
  };

  handleReturnRejectReason = () => {
    // this.is an empty function
  };

  handleReturnRevisionInformation = () => {
    // this.is an empty function
  };

  handleReturnPageName = () => {
    // this is an empty function
  };

  render() {
    const { procedureStatus, receiveDate, requestByName } = this.props.pageProps;
    const { taskInfoData, procedureInfoData, ppoList } = this.props.sectionProps;
    const params = {
      TaskId: this.props.params.ProcedureTaskId,
      ProcedureID: this.props.params.ProcedureID,
      ProcedureStepID: this.props.params.ProcedureStepID,
    };

    return (
      // @ts-ignore
      <div className={styles.approveNewPro}>
        <PageHeader
          title={this.handleReturnPageName()}
          receiveDate={this._formateDate(receiveDate)}
          requestBy={requestByName}
          status="Complete"
        />
        <ProcedureBlock
          className={styles.approveProcedureBlock}
          child={<TaskInformation data={taskInfoData} />}
          testid="task-info-block-arrow"
          isShowArrow={true}
          isOpen={false}
        />
        {/* @ts-ignore */}
        {this.handleReturnRevisionInformation()}
        <ProcedureBlock
          className={styles.approveProcedureFile}
          child={this.handleReturnProcedureFileSection()}
          testid="procedure-file-block-arrow"
          isShowArrow={true}
          isOpen={true}
        />
        <ProcedureBlock
          className={styles.approveProcedureBlock}
          child={
            <ReadOnlySupportingFileSection
              supportingFileData={this.props.supportingTableData}
              supportingFileRef={supportingFileRef}
              supportingFileTableRef={supportingFileTableRef}
            />
          }
          testid="supporting-file-block-arrow"
          isShowArrow={true}
          isOpen={false}
          onShowDataLoad={() => {
            return StepService.getStepData(
              params,
              this.props.setSupportingFileData,
              this.setError,
              [CompleteStepBusinessType.supportingFile],
              StepService.getMergePayloadBySettingKey([
                CompleteStepBusinessType.supportingFile.settingKey,
              ])
            );
          }}
        />
        <ProcedureBlock
          className={styles.approveProcedureBlock}
          child={
            <ProcedureInformation
              isShowActions={false}
              noteDisabled={true}
              ppoList={ppoList}
              procedureStatus={procedureStatus}
              isPPODisabled={true}
              submitData={procedureInfoData}
              title="Procedure Information"
            />
          }
          testid="procedure-info-block-arrow"
          isShowArrow={true}
          isOpen={false}
          onShowDataLoad={() => {
            return StepService.getStepData(
              params,
              this.props.setProcedureInfoData,
              this.setError,
              [
                CompleteStepBusinessType.procedureOwner,
                CompleteStepBusinessType.pmpExcluded,
                CompleteStepBusinessType.primaryProcedureOwner,
              ],
              StepService.getMergePayloadBySettingKey([
                CompleteStepBusinessType.procedureOwner.settingKey,
                CompleteStepBusinessType.pmpExcluded.settingKey,
                CompleteStepBusinessType.primaryProcedureOwner.settingKey,
              ])
            );
          }}
        />
        {/* @ts-ignore */}
        <ProcedureBlock
          className={styles.approveProcedureBlock}
          child={<ActiveShareTaskReadOnly shareTaskData={this.props.shareTaskData} />}
          testid="share-task-block-arrow"
          isShowArrow={true}
          onShowDataLoad={() => {
            return StepService.getStepData(
              params,
              this.props.setShareTaskData,
              this.setError,
              [CompleteStepBusinessType.shareTask],
              StepService.getMergePayloadBySettingKey([
                CompleteStepBusinessType.shareTask.settingKey,
              ])
            );
          }}
        />
        {/* @ts-ignore */}
        {this.handleReturnRejectReason()}
      </div>
    );
  }
}
